import axios from 'axios';
import { useAuthStore } from '@/stores/authStore';

const API_URL = process.env.VUE_APP_API_URL;

const apiPrivate = axios.create({
    baseURL: API_URL,
    withCredentials: true,
});

// Intercepteur des réponses
apiPrivate.interceptors.response.use(
    response => response,
    async error => {
        const authStore = useAuthStore();
        const originalRequest = error.config;

        // Ignore if no response
        if (!error.response) return Promise.reject(error);

        const status = error.response.status;

        // Si ce n’est pas 401, on rejette
        if (status !== 401) return Promise.reject(error);

        // Si on est déjà en retry → rejette pour éviter boucle
        if (originalRequest._retry) return Promise.reject(error);

        // Ne pas tenter de refresh si la requête est le refresh-token lui-même
        if (originalRequest.url.includes('/refresh-token')) {
            return Promise.reject(error);
        }

        // Ne pas tenter de refresh si c'est logout
        if (originalRequest.url.includes('/logout')) {
            return Promise.reject(error);
        }

        // Marque comme tenté
        originalRequest._retry = true;

        try {
            // ⚡ Important : utiliser apiPublic pour refresh-token
            await authStore.refreshToken();

            // Rejouer la requête originale
            return apiPrivate(originalRequest);
        } catch (refreshError) {
            // Logout propre
            await authStore.logout();

            // Redirection seulement si nécessaire
            if (!window.location.pathname.startsWith('/login-register') && !window.location.pathname.startsWith('/home')) {
                window.location.href = '/login-register';
            }

            return Promise.reject(refreshError);
        }
    }
);

export default apiPrivate;
